import React from "react";

type Props = {
  stateName: string;
  displayValue: number;
  num: number; // mapData value for the state (>=0 means has data)
  nValue: number;

  decimalPoint: number;
  popUpString: string;

  yearString: string;
  cohortString: string;
  ageString: string;
  sexString: string;
  insuranceString: string;

  convertGenderString: (s: string) => string;
  formatNumberWithCommas: (n: number) => string | number;
};

const StatePopupContent: React.FC<Props> = ({
  stateName,
  displayValue,
  num,
  nValue,
  decimalPoint,
  popUpString,
  yearString,
  cohortString,
  ageString,
  sexString,
  insuranceString,
  convertGenderString,
  formatNumberWithCommas,
}) => {
  if (num < 0) return <div>No data!</div>;

  const valueText = formatNumberWithCommas(Number(num.toFixed(decimalPoint)));
  const nText = formatNumberWithCommas(Number(nValue.toFixed(0)));

  return (
    <div>
      <div style={{textAlign: "center", fontWeight: "bold"}}>{stateName}</div>

      {displayValue < 2 ? (
        <div>
          Among {convertGenderString(sexString)} {ageString} with{" "}
          {insuranceString}, there were <b>{valueText}</b> {popUpString}
          {cohortString} cases per 100,000 persons (n={nText}) in {stateName} in{" "}
          {yearString}.
        </div>
      ) : displayValue < 4 ? (
        <div>
          Among {convertGenderString(sexString)} {ageString} with{" "}
          {insuranceString}, there were an estimated <b>{valueText}</b>{" "}
          {popUpString}
          {cohortString} cases in {stateName} in {yearString}.
        </div>
      ) : displayValue < 48 ? (
        <div>
          Among {sexString} prevalent {cohortString} cases {ageString} with{" "}
          {insuranceString}, <b>{valueText}%</b> (n={nText}) {popUpString} in{" "}
          {stateName} in {yearString}.
        </div>
      ) : displayValue < 54 ? (
        <div>
          Among {sexString} {cohortString} cases {ageString} with{" "}
          {insuranceString} that underwent SRT in {yearString},{" "}
          <b>{valueText}%</b> (n={nText}) {popUpString} in {stateName}.
        </div>
      ) : displayValue < 67 ? (
        <div>
          Among {sexString} prevalent {cohortString} cases {ageString} with{" "}
          {insuranceString}, {popUpString} <b>${valueText}</b> in {stateName} in{" "}
          {yearString}.
        </div>
      ) : displayValue < 76 ? (
        <div>
          Among {sexString} prevalent {cohortString} cases {ageString} with{" "}
          {insuranceString}, <b>{valueText}%</b> (n={nText}) {popUpString} in{" "}
          {stateName} in {yearString}.
        </div>
      ) : displayValue === 76 ? (
        <div>
          <b>{valueText}%</b> of {convertGenderString(sexString)} {ageString}{" "}
          were living in poverty in {stateName} in {yearString}.
        </div>
      ) : displayValue === 77 ? (
        <div>
          <b>{valueText}%</b> of {convertGenderString(sexString)} {ageString}{" "}
          were uninsured in {stateName} in {yearString}.
        </div>
      ) : displayValue < 81 ? (
        <div>
          Among {sexString} prevalent {cohortString} cases {ageString} with{" "}
          {insuranceString}, <b>{valueText}%</b> {popUpString} in {stateName} in{" "}
          {yearString}.
        </div>
      ) : (
        <div>
          <b>{valueText}%</b> of {convertGenderString(sexString)} {ageString}{" "}
          {popUpString} in {stateName} in {yearString}.
        </div>
      )}
    </div>
  );
};

export default StatePopupContent;
